import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';

// Libs
import { difference } from 'ramda';
import { MaxRectsPacker, IOption, Rectangle } from 'maxrects-packer';

// CSS
import 'react-perfect-scrollbar/dist/css/styles.css';
import './Render.scss';

// Componentes
import RenderScene from './RenderScene';
import PerfectScrollbar from 'react-perfect-scrollbar';

// Redux
import { setZoomAction, ZoomData } from '../../../../Redux/Actions/Atlas/zoom.action';
import { ImageData } from '../../../../Redux/Actions/Atlas/images.action';
import { payloadAlgorithmPanel } from '../../../../Redux/Actions/Atlas/algorithmPanel.action';
import { setMaxRect } from '../../../../Redux/Actions/Atlas/maxrect.action';
import { RootState } from '../../../../Redux/Store/store';

// Utils
import prepareJSON from '../../../../utils/prepareJSON';
import { Observer, GLOBAL_EVENT } from '../../Observer';
import { MaxRectTool } from '../../../../utils/maxRectTool';

interface propsData {
    zoom: number;
    images: ImageData[];
    algorithmPanel: payloadAlgorithmPanel;
    setZoomAction: (value: ZoomData) => void;
    setMaxRect: (value: any) => void;
}

let _scrollBarRef: any;
class Render extends Component<propsData> {
    game: any;
    canvas_container: React.RefObject<HTMLDivElement> = createRef<HTMLDivElement>();
    // Zoom step
    zoom_step: number = 20;

    constructor(props: any) {
        super(props);
        this.handleWheel = this.handleWheel.bind(this);

        Observer.on(GLOBAL_EVENT.PANEL_RESIZE_END, () => {
            _scrollBarRef.updateScroll();
        });

        Observer.on(GLOBAL_EVENT.RESET_ATLAS, () => {
            this.deleteGame();
            this.setGame();
        });
    }

    handleDrag(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        if (!!event.buttons) {
            const scroll = document.querySelector('.scrollContainer') as HTMLDivElement;
            scroll.scrollLeft = scroll.scrollLeft - event.movementX;
            scroll.scrollTop = scroll.scrollTop - event.movementY;
            _scrollBarRef.updateScroll();
        }
    }

    handleWheel(event: any): void {
        if (event.ctrlKey) {
            const zoom = this.props.zoom;
            let value = zoom;
            if (Math.abs(event.deltaY) >= 0) {
                if (zoom >= 20 && zoom <= 500) {
                    value = Number(
                        (
                            zoom -
                            (this.zoom_step * event.deltaY) / Math.abs(event.deltaY)
                        ).toPrecision(2)
                    );
                    value = value < 20 ? (value = 20) : value > 500 ? (value = 500) : value;
                }
            }
            this.props.setZoomAction({ value });
            event.preventDefault();
            event.stopPropagation();
        }
    }

    maxRectPacker(data: any, algorithm: string) {
        const extrusion =
            this.props.algorithmPanel.separation + this.props.algorithmPanel.extrusion * 2;
        const border = this.props.algorithmPanel.separation + this.props.algorithmPanel.extrusion;
        const options: IOption = {
            smart: true,
            pot: false,
            square: false,
            allowRotation: false,
            tag: false,
            border,
        };

        let packer =
            algorithm === 'maxrect'
                ? new MaxRectsPacker(
                      this.props.algorithmPanel.width,
                      this.props.algorithmPanel.height,
                      extrusion,
                      options
                  )
                : new MaxRectTool(this.props.algorithmPanel.size, border);

        let Entrada: Rectangle[] = prepareJSON(data);
        packer.addArray(Entrada);
        const MaxRectGrid: any = packer.bins[0];
        const MaxRectRedux = MaxRectGrid.rects;
        this.props.setMaxRect(MaxRectRedux);

        return MaxRectGrid;
    }

    UNSAFE_componentWillMount() {
        this.deleteGame();
    }

    deleteGame() {
        if (this.game !== undefined) {
            (this.game as Phaser.Game).destroy(true);
            this.game = undefined;
        }
    }

    setGame() {
        const renderConfig = {
            width: 0,
            height: 0,
            parent: 'render',
            type: Phaser.CANVAS,
            backgroundColor: 'rgba(0,0,0,0)',
            dom: {
                createContainer: true,
            },
            banner: {
                hidePhaser: true,
            },
            audio: {
                noAudio: true,
            },
            render: {
                pixelArt: true,
            },
            scene: [RenderScene],
        };
        this.game = new Phaser.Game(renderConfig);
        // Sistema de zoom, se agrega el evento para escuchar la rueda del ratón
        this.canvas_container.current?.addEventListener('wheel', this.handleWheel, {
            passive: false,
        });
        // Evento de carga para Phaser canvas
        /**
         * Cuando se cargan las escenas Phaser nos envía el evento Ready.
         * Nosotros emitimos el evento de IMAGE_CHARGED para cargar elas imágenes.
         * Cuando se complete Phaser nos responde con que las imágenes están completas en su cache
         * Nosotros emitimos el evento IMAGE_CHARGED_COMPLETE para asignar el maxrect
         */
        this.game.registry.events.on(Phaser.Scenes.Events.READY, () => {
            Observer.emit(GLOBAL_EVENT.IMAGE_CHARGED, this.props.images);
            this.game.scene.getScene('RenderScene').load.on('complete', () => {
                // Corrección cuando se borran todas las imagenes para que no falle la aplicación.
                if (this.props.images.length >= 1) {
                    const MaxRectGrid = this.maxRectPacker(
                        this.props.images,
                        this.props.algorithmPanel.type
                    );
                    Observer.emit(GLOBAL_EVENT.IMAGE_CHARGED_COMPLETE, MaxRectGrid);
                } else if (this.props.images.length <= 0) {
                    this.props.setMaxRect([]);
                    Observer.emit(GLOBAL_EVENT.IMAGE_CHARGED_COMPLETE, undefined);
                }
                _scrollBarRef.updateScroll();
            });
        });
    }

    componentDidMount() {
        this.setGame();
    }

    componentDidUpdate(state: propsData) {
        const algorithm_panel_change = difference(
            [state.algorithmPanel],
            [this.props.algorithmPanel]
        ).length;
        if (state.images.length !== this.props.images.length || algorithm_panel_change >= 1) {
            Observer.emit(GLOBAL_EVENT.IMAGE_CHARGED, this.props.images);
        }
        if (state.zoom !== this.props.zoom) {
            const new_zoom: number = this.props.zoom / 100;
            Observer.emit(GLOBAL_EVENT.ZOOM_CHANGED, new_zoom);
        }
        _scrollBarRef.updateScroll();
    }

    render() {
        return (
            <div className="lienzo" ref={this.canvas_container}>
                <PerfectScrollbar
                    className="scrollContainer"
                    ref={(ref) => {
                        _scrollBarRef = ref;
                    }}
                >
                    <div
                        id="render"
                        onMouseMove={this.handleDrag}
                        style={{ display: this.props.images.length <= 0 ? 'none' : 'block' }}
                    ></div>
                    <div className="logo noselect">
                        <img
                            src={require('../../../../Vendor/logo.gif')}
                            alt="logo"
                            draggable={false}
                            style={{ display: this.props.images.length >= 1 ? 'none' : 'block' }}
                        />
                    </div>
                </PerfectScrollbar>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        zoom: state.zoomAtlas.value,
        images: state.imagesAtlas,
        algorithmPanel: state.algorithmPanelAtlas,
    };
};
const mapDispatchToProps = {
    setZoomAction,
    setMaxRect,
};

export default connect(mapStateToProps, mapDispatchToProps)(Render);
